const LEAGUE_PLACEHOLDER = "/league-logos/placeholders/default.svg";
const CLUB_PLACEHOLDER = "/club-logos/placeholders/default.svg";

export function getLeagueLogoUrl(league: { logoUrl: string | null }, externalLogoUrl?: string | null): string {
  return externalLogoUrl ?? league.logoUrl ?? LEAGUE_PLACEHOLDER;
}

export function getTeamLogoUrl(team: { logoUrl: string | null; externalTeam?: { crest: string | null } | null }): string {
  return team.externalTeam?.crest ?? team.logoUrl ?? CLUB_PLACEHOLDER;
}
